import CopySnippet from 'components/CopySnippet';
import CopyValue from 'components/CopyValue';
import { Breadcrumbs } from 'components/index';
import { useUser } from 'contexts/user';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Header } from 'semantic';
import { getToken } from 'utils/api';
import { API_URL } from 'utils/env';

const curlCommand = `
curl -X POST https://sandbox-api.e-flux.nl/2/sessions/cpo/search
  -H "Provider: 5e833daeadadc4003fdf7fb2"
  -H "Content-Type: application/json"
  -H "Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXBlIjoiYXBwbGljYXRpb24iLCJraWQiOiJhcHBsaWNhdGlvbiIsImNyZWRlbnRpYWxJZCI6IjY0MWM2Zjk0NmNmNWY5MDAxMjJiMDJhYiIsImNyZWF0b3JVc2VySWQiOiI2NDFjNmY5NDIyNjQ5ODAwMTI2Njc2MzciLCJpYXQiOjE2Nzk1ODUxNzIsImV4cCI6MTcxMTE0Mjc3Mn0.qY_8K8UMHsbnaaip8Hl-vSKxBT5V4UWmZoomaSwA1Fg"
  --data '{ "limit": 10 }'
`;

export default function SandboxCredentials() {
  const { t } = useTranslation();
  const { provider } = useUser();
  const token = getToken();
  return (
    <Container>
      <Breadcrumbs active={t('sandbox.title', 'Sandbox')} />
      <Header as="h1" style={{ marginBottom: '0', fontWeight: 'normal' }}>
        {t('sandbox.apiCredentialsTitle', 'API Credentials')}
      </Header>
      <p
        style={{
          marginBottom: '0.1rem',
          marginTop: '1rem',
          fontWeight: 500,
          fontSize: '0.9rem',
        }}>
        {t('sandbox.apiCredentialsDescription', 'Authorization credentials')}
      </p>
      <CopyValue value={token} />
      <Header as="h3" style={{ marginBottom: '0', fontWeight: 'normal' }}>
        {t('sandbox.examples', 'Examples')}
      </Header>
      <p
        style={{
          marginBottom: '0.1rem',
          marginTop: '1rem',
          fontWeight: 500,
          fontSize: '0.9rem',
        }}>
        {t('sandbox.retrieveCpoSessions', 'Retrieve CPO sessions')}
      </p>
      <CopySnippet
        language="bash"
        value={`curl -X POST ${API_URL}/2/sessions/cpo/search \\
  -H "Provider: ${provider?.id}" \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer ${token || '<API TOKEN>'}" \\
  --data '{ "limit": 10 }'`}
      />
      <p
        style={{
          marginBottom: '0.1rem',
          marginTop: '2rem',
          fontWeight: 500,
          fontSize: '0.9rem',
        }}>
        {t('sandbox.retrieveMspSessions', 'Retrieve MSP sessions')}
      </p>
      <CopySnippet
        language="bash"
        value={`curl -X POST ${API_URL}/2/sessions/search \\
  -H "Provider: ${provider?.id}" \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer ${token || '<API TOKEN>'}" \\
  --data '{ "limit": 10 }'`}
      />
    </Container>
  );
}
